// HeroVideoTrigger — exact same Play button overlay + VideoPreviewDialog
// modal used on the homepage "Our Collection" property cards
// (see PropertyCardGallery.jsx lines 134-149 + 243-249).
//
// Drop it inside any relatively-positioned hero block to add the same
// top-left play affordance + responsive video modal. All click handlers
// stopPropagation + preventDefault so the surrounding card-wide <Link>
// never triggers when the user opens the video.

import React, { useState } from "react";
import { Play } from "lucide-react";
import VideoPreviewDialog from "@/components/VideoPreviewDialog";

const POSITION_CLASSES = {
  "top-left":     "top-4 left-4 sm:top-5 sm:left-5",
  "bottom-right": "bottom-4 right-4 sm:bottom-5 sm:right-5",
  // Sits next to the auto-injected Xaluca logo watermark when the host
  // uses `data-xaluca-corner="br"`. Values chosen so the play button
  // leaves a comfortable ~14–20px gap next to the logo across mobile
  // (34px logo) → sm (44px) → md (54px). Mirror of the `-left` variant.
  "bottom-right-adjacent": "bottom-4 right-16 sm:bottom-5 sm:right-20 md:right-24",
};

const HeroVideoTrigger = ({ title, testIdPrefix, position = "top-left" }) => {
  const [open, setOpen] = useState(false);
  const posCls = POSITION_CLASSES[position] || POSITION_CLASSES["top-left"];
  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
        className={`absolute ${posCls} z-10 inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 bg-[#1A1513]/55 hover:bg-[#1A1513]/80 text-[#FDFBF7] hover:text-[#D4A373] border border-[#FDFBF7]/35 hover:border-[#D4A373] backdrop-blur-[2px] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A373]`}
        aria-label={`Play video — ${title}`}
        aria-haspopup="dialog"
        data-testid={`${testIdPrefix}-video`}
      >
        <Play className="w-3.5 h-3.5 sm:w-4 sm:h-4 translate-x-[1px]" strokeWidth={1.6} fill="currentColor" />
      </button>
      {open ? (
        <VideoPreviewDialog
          title={title}
          onClose={() => setOpen(false)}
          testIdPrefix={testIdPrefix}
        />
      ) : null}
    </>
  );
};

export default HeroVideoTrigger;
